import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  function validateAndApplyPackageDiscount($form) {
    const packageId = $form.find('#package_id').val();
    const $submitButton = $form.find('.p-button--choose-package-submit');
    const teamSlug = $('meta[name="team-slug"]').attr('content');

    return new Promise((resolve, _) => {
      if (!packageId.length) {
        resolve(true);
        return;
      }
      const data = $form.serialize();
      const validationUrl = $.post(
        `/design_packages/${teamSlug}/${packageId}/xhr_verify_discount_code?${data}`
      );
      validationUrl.then((data) => {
        if (data.error) {
          $('.form-error--apply-package-discount').show();
        } else {
          $('.apply-package-discount-form').addClass('hide');
          $('.applied-package-discount-code').html(data.discount_code);
          $('.applied-package-discount-container').show();
          $submitButton.text(`Complete the Order (${data.total_price_with_tax})`);

          $('.selected-plan__tax-amount').text(data.tax_amount);
          $('.selected-plan__total-amount').text(data.total_price_with_tax);
          $('.selected-plan__discount-percentage').text(data.percentage_amount);
          $('.selected-plan__discount-amount').text(`-${data.discount_amount}`);
          $('.selected-plan--discount').removeClass('hide');
        }
      });
    });
  }

  $(function () {
    $(document).on('click', '.show-package-discount-field', (e) => {
      $('.show-package-discount-field').hide();
      $('.apply-package-discount-form').removeClass('hide').find('input[type=text]').focus();

      return false;
    });

    $(document).on('click', '.h-s-button--apply-package-discount', (e) => {
      $('.form-error--apply-package-discount').hide();

      validateAndApplyPackageDiscount($(e.target).closest('form'));

      return false;
    });

    $(document).on('click', '.remove-applied-package-discount', (e) => {
      $('.apply-package-discount-form').removeClass('hide');
      $('.applied-package-discount-container').hide();
      $('.field--apply-package-discount').val('');

      const $submitButton = $(e.target)
        .parents('.choose-package__form')
        .find('.p-button--choose-package-submit');
      $submitButton.text(`Complete the Order (${$submitButton.data().packagePrice})`);

      $('.selected-plan--discount').addClass('hide');
      $('.selected-plan__tax-amount').text($submitButton.data().packageTax);
      $('.selected-plan__total-amount').text($submitButton.data().packagePrice);

      return false;
    });
  });
});
